import { useQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../context";
import { GET_ALL_COINS } from "../graphql";
import { ECurrencyCode } from "../Enums/Coin";
import { formatAmount } from "../utils";

const useCoinDetails = () => {
  const {
    state: { user },
  } = useAuth();
  const { data: getCoinsData } = useQuery(GET_ALL_COINS);
  const [currentCoin, setCurrentCoin] = useState("1");
  const [currentCoinCode, setCurrentCoinCode] = useState(ECurrencyCode.COLON);

  const [currentSymbolCoin, setCurrentSymbolCoin] = useState("#");
  useEffect(() => {
    if (!user?.TavuelUser?.DefaultCoin) return;

    setCurrentCoin(user.TavuelUser.DefaultCoin.id);
    setCurrentCoinCode(user.TavuelUser.DefaultCoin.Code_Coin);
    setCurrentSymbolCoin(user.TavuelUser.DefaultCoin.Symbol_Coin);
  }, [user]);

  const resetDefaultCoin = useCallback(() => {
    setCurrentCoin(user.TavuelUser.DefaultCoin.id);
    setCurrentSymbolCoin(user.TavuelUser.DefaultCoin.Symbol_Coin);
  }, [user]);
  const handleCoinChange = value => {
    const coin = getCoinsData.coins.find(e => e.id === value);
    if (!coin) return;
    setCurrentCoin(value);
    setCurrentSymbolCoin(coin.Symbol_Coin);
  };

  const toExchangeRate = useCallback(
    amount => {
      if (!getCoinsData?.coins) return 0.0;
      const coin = getCoinsData.coins.find(e => e.id === currentCoin);
      const formattedAmount = coin ? amount / coin.Sell_Coin : amount;
      return parseFloat(formattedAmount);
    },
    [getCoinsData, currentCoin],
  );

  const toLocalExchangeRate = (amount, coin) => {
    if (!coin) return 0.0;
    const formattedAmount = coin ? amount / coin.Sell_Coin : amount;
    return parseFloat(formattedAmount).toFixed(3);
  };

  const toDolar = useCallback(
    amount => {
      if (!getCoinsData?.coins) return 0;
      const coin = getCoinsData.coins.find(e => e.id === currentCoin);
      return parseFloat(`${amount * (coin ? coin.Sell_Coin : 1)}`);
    },
    [currentCoin, getCoinsData],
  );

  const convertToCurrency = ({
    amount,
    fromCurrencyCode,
    toCurrencyCode,
    decilmalsNumber,
  }) => {
    if (!getCoinsData?.coins) return null;
    if (
      typeof amount !== "number" ||
      typeof fromCurrencyCode !== "string" ||
      typeof toCurrencyCode !== "string"
    ) {
      return null;
    }
    if (fromCurrencyCode === toCurrencyCode)
      return formatAmount(amount, decilmalsNumber);

    const baseCurrency = getCoinsData.coins.find(
      c => c.Code_Coin === fromCurrencyCode,
    );
    const targetCurrency = getCoinsData.coins.find(
      c => c.Code_Coin === toCurrencyCode,
    );
    if (!baseCurrency || !targetCurrency) return null;

    const amountInUSD = amount * baseCurrency.Sell_Coin;
    const amountInTargetCurrency = amountInUSD / targetCurrency.Sell_Coin;
    return formatAmount(amountInTargetCurrency, decilmalsNumber);
  };

  return {
    currentCoin,
    currentCoinCode,
    currentSymbolCoin,
    handleCoinChange,
    toExchangeRate,
    toLocalExchangeRate,
    resetDefaultCoin,
    getCoinsData,
    toDolar,
    convertToCurrency,
  };
};

export default useCoinDetails;
